import React from 'react';
import './MemberRoster.css'

const MemberCard = ({member, positions, canEdit}) => {
  function convertInches(inches) {
    let feetFromInches = Math.floor(inches / 12);//There are 12 inches in a foot
    let inchesRemainder = inches % 12;
    let result = feetFromInches + "'" + inchesRemainder + "\"";
    return result
  }
  const {profile_picture, user, edit} = member._links;
  const memberPositions = member.position_ids.map(pos => positions.find(item => item.id === pos));
  const displayPositions = (<>
    {member.number && <span className="me-1">#{member.number},</span>}
    {memberPositions.map((pos, i) => (
      pos && <span className={`position ${i === memberPositions.length - 1 ? "u-removeAfter" : ""} `} key={i} title={pos.name}> {pos.abbrev}</span>))}
    {member.height && <span title="Height" className="ms-2">{convertInches(+member.height)}</span>}
    {member.weight && <span title="Weight" className="ms-1">{member.weight}lbs.</span>}
  </>)

  return (
    <li className="col-12 col-md-6 col-lg-4 mt-3">
      <div className="MemberCard pe-md-2">
        {
          user !== undefined ? (
            <>
              <div className="Post-info d-flex mb-2">
                <a className="me-2" href={user ? user.href : ''}>
                  <img className="MVP-img event-profile" src={profile_picture.href} alt=""/>
                </a>
                <div className="text-start flex-grow-1 Member-Info">
                  <a className="text-start Post-by pe-3 u-teamColorTxt" href={user ? user.href : ''}>
                    { member.last_name }, { member.first_name }
                  </a>
                  <p className="text-start my-1 positions">
                    { positions.length > 0 ? displayPositions : member.title }
                  </p>
                  <p className="GradYear">
                    { member.grad_year ? `Class of ${member.grad_year}` : `(${member.role})` }
                  </p>
                </div>
              </div>
              <a href={ edit.href } className={`editMember ${canEdit? "":'d-none'}`}>
                <small>
                  <i className="fa-solid fa-ellipsis"></i>
                </small>
              </a>
            </>
          ) : (
            <>
              <div className="Post-info d-flex mb-2">
                <img className="MVP-img event-profile me-2" src={profile_picture.href} alt=""/>
                <div className="text-start flex-grow-1 Member-Info">
                  <span className="text-start Post-by pe-3">
                    { member.last_name }, { member.first_name }
                  </span>
                  <p className="text-start my-1 positions">
                    { positions.length > 0 ? displayPositions : member.title }
                  </p>
                  <p className="GradYear">
                    { member.grad_year ? `Class of ${member.grad_year}` : `(${member.role})` }
                  </p>
                </div>
              </div>
              <a href={ edit.href } className={`editMember ${canEdit? "":'d-none'}`}>
                <small>
                  <i className="fa-solid fa-ellipsis"></i>
                </small>
              </a>
            </>
          )
        }
      </div>
    </li>
  );
};

export default MemberCard;
